import _ from "lodash";

export const loginEmailErrors = (state) => {
    return _.get(state, ['loginErrors', 'email'], [])
}

export const loginPasswordErrors = (state) => {
    return _.get(state, ['loginErrors', 'password'], [])
}

export const loginCommonErrors = (state) => {
    return _.get(state, ['loginErrors', 'common'], [])
}